function isSubsAppAvailable() {
  return typeof window.BOLD !== 'undefined'
    && typeof window.BOLD.subscriptions !== 'undefined'
    && typeof window.BOLD.subscriptions.app !== 'undefined';
}

export default {
  methods: {
    bsubHandleAddToCartClick(form, lineItemId) {
      const addToCartData = window.BOLD.subscriptions.classes.CommercetoolsWidgetAdapter.getAddToCartDataFromForm(form);

      if (addToCartData === null) {
        return;
      }
      addToCartData.line_item_id = lineItemId;
      window.BOLD.subscriptions.app.addSuccessfulAddToCart(addToCartData);
    },
    bsubHandleRemoveFromCartClick(lineItemId) {
      if (!isSubsAppAvailable()) {
        return;
      }
      window.BOLD.subscriptions.app.cleanSuccessfulAddToCartsForLineItemId(lineItemId);
    },
  },
};
